import React, { useState, useEffect } from 'react';
import { Wine } from 'lucide-react';
import { hoursOfOperation } from '../config/siteConfig';

const HappyHourBanner = () => {
  const [isHappyHour, setIsHappyHour] = useState(false);
  const [isSunday, setIsSunday] = useState(false);

  useEffect(() => {
    const checkHappyHour = () => {
      const now = new Date();
      const currentHour = now.getHours();
      const currentDay = now.getDay();

      // Check if restaurant is open today
      const dayIndex = currentDay === 0 ? 0 : currentDay;
      const todayHours = hoursOfOperation[dayIndex];

      if (todayHours?.closed) {
        setIsHappyHour(false);
        setIsSunday(false);
        return;
      }

      // Sunday = happy hour all day (open to close)
      if (currentDay === 0) {
        const isOpen = currentHour >= 11 && currentHour < 21;
        setIsHappyHour(isOpen);
        setIsSunday(true);
        return;
      }

      setIsSunday(false);
      // Happy hour is 2pm (14:00) to 6pm (18:00)
      const isWithinHappyHour = currentHour >= 14 && currentHour < 18;
      setIsHappyHour(isWithinHappyHour);
    };

    checkHappyHour();
    const interval = setInterval(checkHappyHour, 60000);
    return () => clearInterval(interval);
  }, []);

  // For demo/testing - set to true to always show:
  const isHappyHourDemo = false;

  if (!isHappyHour && !isHappyHourDemo) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 bg-[#2C2416] border-t border-[#C9A227]/30"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="max-w-6xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-center text-xs sm:text-sm">
        <Wine className="w-4 h-4 text-[#C9A227] animate-pulse" />
        <span className="text-[#C9A227] font-semibold">{isSunday ? 'Sunday Funday!' : "It's Happy Hour!"}</span>
        <span className="hidden sm:inline text-[#FDF6E9]/70">{isSunday ? 'All Day Sunday Happy Hour — $4 House Wine • $2 Off Drafts • $3 Wells • 20% Off All Apps' : '$4 House Wine • $2 Off Drafts • $3 Wells • 20% Off All Apps'}</span>
        <span className="sm:hidden text-[#FDF6E9]/70">$4 wine • $3 wells • 20% off apps</span>
      </div>
    </div>
  );
};

export default HappyHourBanner;
